import ModalAddOutcomesEvent from "./ModalAddOutcomesEvent";

export default ModalAddOutcomesEvent;